import styled from '@emotion/styled';
import * as React from 'react';
import { ContentWidget } from '../widgets/ContentWidget';
import { PageWidget } from '../widgets/layout/PageWidget';
import { CenterWidget } from '../widgets/layout/CenterWidget';
import { SectionWidget } from '../widgets/layout/SectionWidget';

const img_drillrig = require('../../media/customers/img-drilling-rig.jpg');
const img_tanks = require('../../media/customers/img-chemical-tanks.jpg');
const img_drillbit = require('../../media/customers/img-drill-bit.jpg');
const img_workeoverrig = require('../../media/customers/img-workover-rig.jpg');
const img_amat = require('../../media/customers/customers-amat.jpeg');

const img_header = require('../../media/customers/chemicals-video-first-frame.jpg');

export const CustomersPage: React.FC = () => {
  return (
    <PageWidget center={false} title="Customers">
      <S.Section>
        <ContentWidget>
          <CenterWidget width={1200}>
            <SectionWidget
              image={img_header}
              label="Our customers"
              content="Some of the world's largest companies are using JourneyApps Platform to digitally transform their core
            operations through powerful business apps, in industries such as industrial equipment, oil & gas, mining,
            energy, construction and high-tech manufacturing."
              index={1}
            ></SectionWidget>
          </CenterWidget>
        </ContentWidget>
      </S.Section>

      <S.Section>
        <ContentWidget>
          <CenterWidget>
            <h2>
              Reliance Oilfield Services built multiple apps on JourneyApps Platform to accelerate its software and
              digital innovation.
            </h2>
            <p>
              <i>
                "What really appealed to me about JourneyApps was that you could build an Android app, iOS app, and
                Windows app — all with the same codebase. We were able to really just focus on the business problems and
                not have to worry about the technical side of it."
              </i>
            </p>
            <p>-Anthony Licona Director of Innovation and Technology at Edge OFS Holdings</p>
            <S.Video
              dangerouslySetInnerHTML={{
                __html: `
<script src="https://fast.wistia.com/embed/bos3aygv07.js" async type="module"></script>
<style>wistia-player[media-id='bos3aygv07']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/bos3aygv07/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }</style>
<wistia-player media-id="bos3aygv07" aspect="1.7777777777777777"></wistia-player>
        `
              }}
            ></S.Video>
          </CenterWidget>
          <CenterWidget width={1200}>
            <SectionWidget
              ltr={false}
              image={img_tanks}
              label="A Fortune 200 oilfield services chemicals provider
streamlined inventory management and sped up time-to-cash."
              content={
                <ul>
                  <li>
                    JourneyApps Platform allows them to perform site management and job execution tracking, and
                    fast-track the field ticketing process.
                  </li>
                  <li>
                    <b>Benefits include:</b>
                    <br />
                    Standardizing processes across basins, freeing staff from mundane tasks, real-time
                    revenue/performance tracking, real-time visibility on site inventory, and reducing time-to-cash.
                  </li>
                </ul>
              }
              index={2}
            ></SectionWidget>
            <SectionWidget
              image={img_drillbit}
              label="A Fortune 500 oilfield equipment provider improved engineering and reliability by digitizing repair processes."
              content={
                <ul>
                  <li>
                    JourneyApps Platform allows them to manage the repair process from taking in new repair inventory
                    through to final inspection and shipping.
                  </li>
                  <li>
                    The repair process can be tracked on a per-minute granularity, rather than by estimates on paper,
                    enabling an accurate understanding of the true cost of materials and labor.
                  </li>
                  <li>Grading of equipment condition enables metrics to improve engineering & reliability.</li>
                </ul>
              }
              index={3}
            ></SectionWidget>
          </CenterWidget>
        </ContentWidget>
      </S.Section>

      <S.Section>
        <CenterWidget width={1200}>
          <SectionWidget
            ltr={false}
            image={img_workeoverrig}
            label="A Fortune 25 Oil & Gas company optimized well intervention
by improving workover rig management."
            content={
              <ul>
                <li>
                  JourneyApps Platform allows well operators to log rig requests along with information on failure,
                  equipment and well production, allows engineers to specify engineering details and procedures, and
                  allows foremen to prioritize and assign rigs.
                </li>
                <li>
                  <b>Benefits include:</b>
                  <br />
                  Streamlined communication and coordination between operators and engineers, better prioritization of
                  interventions on high-producing wells, central visibility on workover requirements, and reducing the
                  number of rigs required per basin.
                </li>
              </ul>
            }
            index={1}
          ></SectionWidget>
        </CenterWidget>
      </S.Section>

      <S.Section>
        <ContentWidget>
          <CenterWidget>
            <h2>
              Buckeye Partners achieved six figures of cost savings for their customers with an application built on
              JourneyApps Platform.
            </h2>
            <p>
              <i>
                "Within Buckeye, we have made it a strategic priority to be ahead of the technological curve and utilize
                technology to our advantage. I think there are endless opportunities to utilize JourneyApps throughout
                our organization."
              </i>
            </p>
            <p>-Joe Votta Senior Director, Global Marine Terminals</p>
          </CenterWidget>
          <CenterWidget>
            <S.Video
              dangerouslySetInnerHTML={{
                __html: `
<script src="https://fast.wistia.com/embed/ma233kwd43.js" async type="module"></script>
<style>wistia-player[media-id='ma233kwd43']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/ma233kwd43/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }</style>
<wistia-player media-id="ma233kwd43" aspect="1.7777777777777777"></wistia-player>
        `
              }}
            ></S.Video>
          </CenterWidget>
          <CenterWidget width={1200}>
            <SectionWidget
              image={img_drillrig}
              label="A Fortune 150 oilfield services drilling contractor delivered on
more jobs in a growing market with the same headcount."
              content={
                <ul>
                  <li>
                    JourneyApps Platform allows them to connect business development, technical advisors, service
                    planners, coordinators, repair & maintenance and field engineers as they take a job from opportunity
                    through completion.
                  </li>
                  <li>
                    From opportunity creation through tool forecasts, crew assignments, tool requests, daily field
                    reporting and ticket review, the solution provides users with an intelligent, digital way to execute
                    their work.
                  </li>
                  <li>
                    The lifecycle of each job is virtually tracked, enabling a dashboard showing the status of each job,
                    as well as whether any service interrupts have occurred.
                  </li>
                </ul>
              }
              index={2}
            ></SectionWidget>
          </CenterWidget>
        </ContentWidget>
      </S.Section>

      <S.Section>
        <ContentWidget>
          <CenterWidget>
            <h2>Sandvik and JourneyApps: a digital transformation partnership.</h2>
            <p>
              <i>
                "What we are accomplishing in partnership with JourneyApps is helping us be a technology leader and a
                service leader."
              </i>
            </p>
            <p>-Charles Macfadyen Digital Solutions, Rock Tools</p>
            <S.Video
              dangerouslySetInnerHTML={{
                __html: `
<script src="https://fast.wistia.com/embed/185lndtbrh.js" async type="module"></script>
<style>wistia-player[media-id='185lndtbrh']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/185lndtbrh/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }</style>
<wistia-player media-id="185lndtbrh" aspect="1.7777777777777777"></wistia-player>
        `
              }}
            ></S.Video>
          </CenterWidget>
        </ContentWidget>
      </S.Section>

      <S.Section>
        <CenterWidget width={1200}>
          <SectionWidget
            image={img_amat}
            label="Applied Materials added a mobile app to their overhauled SAP systems in only 8 weeks with JourneyApps Platform."
            content={
              <ul>
                <li>
                  After launching a major ERP system initiative, Applied Materials required a mobile solution to allow
                  job scheduling for field technicians, in a rapid timeframe.
                </li>
                <li>
                  Typically, developing such a solution within an ERP system would be slow and complicated due to the
                  complexity and governance requirements.
                </li>
                <li>
                  JourneyApps Platform was used to deliver a much more flexible solution much faster, that complements
                  and integrates with their SAP ERP system.
                </li>
                <li>The solution was rolled out globally to thousands of users.</li>
              </ul>
            }
            index={3}
          ></SectionWidget>
        </CenterWidget>
      </S.Section>

      <S.Section>
        <ContentWidget>
          <CenterWidget>
            <h2>GE Healthcare Partners improved the efficiency of their time studies by 3x-5x.</h2>
            <p>
              <i>
                "In this fast-paced world, when you encounter a problem, you can't spend months looking for a solution.
                JourneyApps created refreshing simplicity and speed which made selecting them a very simple decision."
              </i>
            </p>
            <p>- Laura Jacobs Managing Principal, GE Healthcare Partners</p>
            <S.Video
              dangerouslySetInnerHTML={{
                __html: `
<script src="https://fast.wistia.com/embed/wxos5f732s.js" async type="module"></script>
<style>wistia-player[media-id='wxos5f732s']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/wxos5f732s/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }</style>
<wistia-player media-id="wxos5f732s" aspect="1.7777777777777777"></wistia-player>
        `
              }}
            ></S.Video>
          </CenterWidget>
        </ContentWidget>
      </S.Section>

      <S.Section>
        <ContentWidget>
          <CenterWidget>
            <h2>Emerson built an ecosystem of more than a dozen apps.</h2>
            <p>
              <i>"JourneyApps is truly a platform that allows us to bring innovation to market faster."</i>
            </p>
            <p>-Denny Cahill VP Global Lifecycle Services, Emerson</p>
            <S.Video
              dangerouslySetInnerHTML={{
                __html: `
<script src="https://fast.wistia.com/embed/s6qc2eq2mn.js" async type="module"></script>
<style>wistia-player[media-id='s6qc2eq2mn']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/s6qc2eq2mn/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }</style>
<wistia-player media-id="s6qc2eq2mn" aspect="1.7777777777777777"></wistia-player>
        `
              }}
            ></S.Video>
          </CenterWidget>
        </ContentWidget>
      </S.Section>
      <S.Section>
        <ContentWidget>
          <CenterWidget>
            <h2>
              Aviat Networks reduced the time to complete site surveys by 66% with JourneyApps Platform in only 2 weeks.
            </h2>
            <p>
              <i>
                "In the way that Aviat has done emergent digital transformation, we’ve taken small — but critical —
                bites in the form of digitizing components of our business, instead of saying 'I want a system that does
                everything'. Those small, critical bites are eventually tied together to cover the full spectrum of our
                Services business end-to-end."
              </i>
            </p>
            <p>- Pat Davis VP Global Services</p>
            <S.Video
              dangerouslySetInnerHTML={{
                __html: `
<script src="https://fast.wistia.com/embed/pri40qpjq5.js" async type="module"></script>
<style>wistia-player[media-id='pri40qpjq5']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/pri40qpjq5/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }</style>
<wistia-player media-id="pri40qpjq5" aspect="1.7777777777777777"></wistia-player>
        `
              }}
            ></S.Video>
          </CenterWidget>
        </ContentWidget>
      </S.Section>
    </PageWidget>
  );
};
namespace S {
  export const Video = styled.div`
    margin-top: 30px;
  `;

  export const Section = styled.div`
    padding-top: 60px;
    padding-bottom: 60px;
    &:nth-child(odd) {
      background: ${(p) => p.theme.card.background};
    }
  `;
}
